import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { I18n } from 'react-redux-i18n-lite';
import _ from 'lodash';

import { ClassroomCardNew } from '@netexknowledge/smart-components';
import * as classroomActions from '../../../actions/classroom/classroomActions';
import * as revealActions from '../../../actions/revealActions';
import * as messageAlert from '../../../actions/messageAlertAction';
import { CLASSROOM_MODES, ROLE } from '../../../const';
import { getClassroomImageUrl } from '../../../services/assets/assetsService';
import { getClassroomTo } from '../../../utils/routeUtils';
import { getRoleChipLabel } from '../../../utils/classroomRoleUtils';
import routerHistory from './../../../routerHistory';
import Media from 'react-media';
import { MOBILE_MEDIA_QUERY } from '../../../utils/mobileUtils';
import MoreOptions from '../../common/sheets/MoreOptions';

class ClassroomActiveCardCommon extends React.Component {
  handleArchiveClassroom = () => {
    const { isAppOnline } = this.props;
    if (isAppOnline) {
      const { classroomActions, id, name } = this.props;
      let data = { id: id, name: name };
      classroomActions.setArchiveClassroomData(data);
    }
  };

  openEditClassroomReveal = () => {
    let { classroomActions, id, classCode, name, studentsCount, picture, asset } = this.props;

    classroomActions.setClassroomInfo({
      id,
      classCode,
      name,
      studentsCount,
      picture,
      asset
    });
    classroomActions.setAddModalState(true);
  };

  isTeacher = () => {
    const { role } = this.props;
    return [ROLE.INSTRUCTOR].includes(role);
  };

  getOptions = extraMenuOptions => {
    const { role, archiveEnabled, enableCreateClass, isAppOnline } = this.props;

    const configOption = {
      key: 1,
      text: I18n.t('common.option.config'),
      onClick: this.openEditClassroomReveal,
      icon: 'custom-icons-options-gear',
      disabled: !isAppOnline
    };

    const classcodeOption = {
      key: 3,
      text: I18n.t('leftMenu.classcode'),
      onClick: this.openClassCodeReveal,
      icon: 'custom-icons-television-screen',
      disabled: false
    };

    const archiveOption = {
      key: 4,
      text: I18n.t('common.option.archive'),
      onClick: this.handleArchiveClassroom,
      icon: 'custom-icons-download-tray',
      disabled: !isAppOnline
    };

    const unEnrollOption = {
      key: 5,
      text: I18n.t('common.option.unenroll'),
      onClick: this.handleUnErollClassroom,
      icon: 'custom-icons-logout',
      disabled: !isAppOnline
    };

    const options = {
      [ROLE.INSTRUCTOR]:
        archiveEnabled && enableCreateClass
          ? [configOption, classcodeOption, archiveOption]
          : archiveEnabled
          ? [configOption, archiveOption]
          : enableCreateClass
          ? [configOption, classcodeOption]
          : [configOption],
      [ROLE.COINSTRUCTOR]: enableCreateClass ? [classcodeOption, unEnrollOption] : [],
      [ROLE.STUDENT]: []
    };
    const selectedOptions = options[role];

    if (extraMenuOptions) {
      extraMenuOptions.forEach(o => {
        selectedOptions.splice(o.position, 0, o.option);
      });
    }
    return selectedOptions;
  };

  handleUnErollClassroom = () => {
    const { isAppOnline, classroomActions, id, user, revealActions } = this.props;

    if (!isAppOnline) {
      return;
    }

    revealActions.setCustomConfirmModalOpened(true, I18n.t('common.unenrollConfirmation'), () =>
      classroomActions.unenrollTeacher(user._id, id).then(() => {
        classroomActions.getActiveClassroomData();
      })
    );
  };

  openClassCodeReveal = () => {
    const { classroomActions, id, activeClassrooms } = this.props;
    const classroom = _.find(activeClassrooms, v => {
      if (v.id === id) {
        return v;
      }
    });
    classroomActions.setClassroomInfo(classroom);
    classroomActions.setClassCodePopupOpen(true);
  };

  renderEmptyLoadBar = () => {
    // Exists only because it is required by CardLarge to receive a renderLoadBar function
    return;
  };

  resolveEntryPoint = () => {
    const { id, classroomTabs } = this.props;
    return getClassroomTo(id, classroomTabs[0]);
  };

  getRoleValue(role) {
    return getRoleChipLabel(this.props.user.role, role);
  }

  render() {
    const {
      id,
      name,
      studentsCount,
      isDragging,
      renderLoadBar,
      extraMenuOptions,
      picture,
      asset,
      classroomMode,
      role
    } = this.props;
    const textTop = `${name}`;
    const textBottom =
      CLASSROOM_MODES.EDUCATIONAL === classroomMode ? `${studentsCount} ${I18n.t('classroom.students')}` : '';
    const entryPoint = this.resolveEntryPoint();
    const optionItems = this.getOptions(extraMenuOptions);
    const renderLoadBarFinal = renderLoadBar || this.renderEmptyLoadBar;
    let classroomImgUrl = getClassroomImageUrl(id, picture || asset);

    return (
      <Media query={MOBILE_MEDIA_QUERY}>
        {isMobile => {
          // Mobile: the card's own dropdown is hidden (it is always rendered for non students) and a ⋮
          // that opens the options in a bottom sheet takes its place
          const sheetOptions = isMobile && role !== ROLE.STUDENT && optionItems.length > 0;
          return (
            <div
              className={`classroom-active-card no-user-selection ${
                sheetOptions ? 'classroom-active-card--sheet-options' : ''
              }`}
            >
              <ClassroomCardNew
                id={id}
                name={textTop}
                studentsCount={textBottom}
                picture={classroomImgUrl}
                options={sheetOptions ? [] : optionItems}
                role={role}
                roleTranslation={this.getRoleValue(role)}
                onClick={() => {
                  routerHistory.push(`${entryPoint}`);
                }}
              />
              {sheetOptions && (
                <div className="classroom-active-card__options">
                  <MoreOptions
                    id={`classroom-sheet-options-${id}`}
                    color="gray"
                    // String keys: ActionSheet moves key 3 (Edit) first, here it is the class code
                    options={optionItems.map(option => ({ ...option, key: `classroom-option-${option.key}` }))}
                    sheetTitle={textTop}
                    sheetOverline={I18n.t('mobileSheets.classroom')}
                    sheetMedia={
                      <span className="sheet-media-image" style={{ backgroundImage: `url(${classroomImgUrl})` }} />
                    }
                  />
                </div>
              )}
            </div>
          );
        }}
      </Media>
    );
  }
}

ClassroomActiveCardCommon.propTypes = {
  role: PropTypes.string,
  user: PropTypes.object.isRequired,
  id: PropTypes.any.isRequired,
  name: PropTypes.string.isRequired,
  studentsCount: PropTypes.number.isRequired,
  isDragging: PropTypes.bool,
  isAppOnline: PropTypes.any,
  classroomActions: PropTypes.any,
  messageAlert: PropTypes.any,
  archiveEnabled: PropTypes.any,
  renderLoadBar: PropTypes.any,
  extraMenuOptions: PropTypes.any,
  classroomsImages: PropTypes.any,
  picture: PropTypes.string,
  asset: PropTypes.string,
  classCode: PropTypes.string,
  activeClassrooms: PropTypes.array,
  enableCreateClass: PropTypes.bool,
  classroomMode: PropTypes.string,
  classroomTabs: PropTypes.array
};

ClassroomActiveCardCommon.defaultProps = {
  studentsCount: 0
};

function mapStateToProps(state) {
  return {
    user: state.account.user,
    i18n: state.i18n,
    isAppOnline: state.connection.status.online,
    classroomsImages: state.theme.images.classrooms,
    archiveEnabled: state.account.configuration.archiveEnabled,
    enableEnrollment: state.account.configuration.enableEnrollment,
    enableCreateClass: state.account.configuration.enableCreateClass,
    activeClassrooms: state.classrooms.activeClassrooms,
    classroomMode: state.account.configuration.classroomMode,
    classroomTabs: state.account.configuration.classroomTabs
  };
}

function mapDispatchToProps(dispatch) {
  return {
    revealActions: bindActionCreators(revealActions, dispatch),
    classroomActions: bindActionCreators(classroomActions, dispatch),
    messageAlert: bindActionCreators(messageAlert, dispatch),
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ClassroomActiveCardCommon);
